import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Alert, Row } from 'reactstrap';
import Label from 'components/Input/Label';
import ButtonLink from 'components/ButtonLink';
import LargestCol from 'components/LargestCol';
import {
  CANCELLATION_POLICY,
  PROPERTY_TERMS_AND_CONDITIONS_FULL
} from 'utils/messages/termsAndConditions';
import { getBookingEnginePath } from 'utils/routeUtils';

const InfoRow = styled(Row)`
  & > div {
    margin-bottom: 1em;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.small}) {
    & > div {
      margin-bottom: 0;
    }
  }
`;

function EnteredGuestInfo({
  guestInfo,
  property,
  toggleTermsAndConditionsModal,
  isHostBookingAdmin,
  compCredit
}) {
  return (
    <React.Fragment>
      <Row>
        <LargestCol xs="12" xl="6">
          <Row>
            <LargestCol xs="12">
              <h5>CONTACT INFORMATION</h5>
              <Link
                to={{
                  pathname: getBookingEnginePath('guest-information'),
                  state: { transitionDirection: 'back' }
                }}
                aria-label="Edit contact information"
              >
                Edit
              </Link>
            </LargestCol>
          </Row>
          <Row>
            <LargestCol xs="6">
              <Label>First Name</Label>
              <span>{guestInfo.firstName}</span>
            </LargestCol>
            <LargestCol xs="6">
              <Label>Last Name</Label>
              <span>{guestInfo.lastName}</span>
            </LargestCol>
          </Row>
          <Row>
            <LargestCol xs="12">
              <Label>Email Address</Label>
              <span>{guestInfo.email}</span>
            </LargestCol>
          </Row>
          <Row>
            <LargestCol xs="12">
              <Label>Phone Number</Label>
              <span>{guestInfo.phone}</span>
            </LargestCol>
          </Row>
        </LargestCol>
        <LargestCol xs="12" xl="6">
          <Row>
            <LargestCol xs="12">
              <h5>BILLING ADDRESS</h5>
              <Link
                to={{
                  pathname: getBookingEnginePath('guest-information'),
                  state: { transitionDirection: 'back' }
                }}
                aria-label="Edit billing address"
              >
                Edit
              </Link>
            </LargestCol>
          </Row>
          <Row>
            <LargestCol xs="12">
              <Label>Address</Label>
              <span>{guestInfo.address}</span>
            </LargestCol>
          </Row>
          <Row>
            <LargestCol xs="4">
              <Label>City</Label>
              <span>{guestInfo.city}</span>
            </LargestCol>
            <LargestCol xs="4">
              <Label>State</Label>
              <span>{guestInfo.state.label}</span>
            </LargestCol>
            <LargestCol xs="4">
              <Label>Zip Code</Label>
              <span>{guestInfo.postalCode}</span>
            </LargestCol>
          </Row>
        </LargestCol>
      </Row>
      {!isHostBookingAdmin && (
        <Row>
          <LargestCol xs="12">
            <Row>
              <LargestCol xs="12">
                <h5>CREDIT CARD INFORMATION</h5>
                <Link
                  to={{
                    pathname: getBookingEnginePath('guest-information'),
                    state: { transitionDirection: 'back' }
                  }}
                  aria-label="Edit credit card information"
                >
                  Edit
                </Link>
              </LargestCol>
            </Row>
            <Row>
              <LargestCol xs="4" sm="3">
                <Label>Card Type</Label>
                <span>{guestInfo.cardType.label}</span>
              </LargestCol>
              <LargestCol xs="4" sm="3">
                <Label>Card Number</Label>
                <span>**** **** **** {guestInfo.cardNumber.substr(-4)}</span>
              </LargestCol>
              <LargestCol xs="4" sm="6">
                <Label>CVV</Label>
                <span>{guestInfo.cvv}</span>
              </LargestCol>
            </Row>
            <InfoRow>
              <LargestCol xs="6" sm="3">
                <Label>Expiration Month</Label>
                <span>{guestInfo.expirationMonth.label}</span>
              </LargestCol>
              <LargestCol xs="6" sm="3">
                <Label>Expiration Year</Label>
                <span>{guestInfo.expirationYear.label}</span>
              </LargestCol>
            </InfoRow>
          </LargestCol>
        </Row>
      )}
      {compCredit && (
        <Row>
          <LargestCol xs="12">
            <Label>Comp Routing Request</Label>
            <span>{compCredit}</span>
          </LargestCol>
        </Row>
      )}
      <p className="cancellation-policy">{CANCELLATION_POLICY(property)}</p>
      {PROPERTY_TERMS_AND_CONDITIONS_FULL[property] && (
        <p className="cancellation-policy">
          <ButtonLink onClick={toggleTermsAndConditionsModal}>
            See full terms and conditions
          </ButtonLink>
        </p>
      )}
    </React.Fragment>
  );
}

EnteredGuestInfo.propTypes = {
  guestInfo: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    cardType: PropTypes.string,
    cardNumber: PropTypes.string,
    expirationMonth: PropTypes.string,
    expirationYear: PropTypes.number,
    cvv: PropTypes.number
  }),
  property: PropTypes.string,
  toggleTermsAndConditionsModal: PropTypes.func,
  isHostBookingAdmin: PropTypes.bool,
  compCredit: PropTypes.string
};

export default EnteredGuestInfo;
